import { type FunctionComponent, useContext } from 'react';
import { Box } from '@atlaskit/primitives';

import MainContent from '../MainContent';
import ConsentForm from '../../Flow/ConsentForm';
import {
  ReactConsentContext,
  narrowConsentContentStyle,
} from '../../Flow/ConsentContextProvider';
import RovoStickyFooter, { RovoStickyFooterSpacer } from './RovoStickyFooter';

const RovoConsentLayout: FunctionComponent = () => {
  const consentContext = useContext(ReactConsentContext);

  return (
    <Box as="main" xcss={narrowConsentContentStyle}>
      <ConsentForm>
        <MainContent />
        <RovoStickyFooterSpacer />
        <RovoStickyFooter acceptDisabled={consentContext?.acceptDisabled} />
      </ConsentForm>
    </Box>
  );
};

export default RovoConsentLayout;
